export default __webpack_public_path__ + "static/media/240.9957d7f7.jpg";